// Types
export type PromoDetail = {
  slug: string;
  imageKey?: "sculptSocietyImage" | "oseaLipBoosterImage" | "promoDetails40Off" | "promoDetails25Off";
  headline: string;
  expiresAt?: string;
  description: string;
};

export type PromoDetailsData = {
  discountPromoDetails: Record<string, PromoDetail>;
  promoDetails: PromoDetail[];
  disclaimerText: string;
};

// Locale-specific promo details
const PROMO_DETAILS_BY_LOCALE: Record<string, PromoDetailsData> = {
  "en-US": {
    discountPromoDetails: {
      "nys26-prospect": {
        slug: "nys26-prospect",
        imageKey: "promoDetails40Off",
        headline: "40% Off Sitewide",
        description: "Get 40% off your first month’s subscription",
      },
      "nys26-customer": {
        slug: "nys26-customer",
        imageKey: "promoDetails25Off",
        headline: "25% Off New Subscription Items",
        description:
          "Eligible customers will receive 25% off the regular price of any new subscription item.",
      },
    },
    promoDetails: [
      {
        slug: "sculpt-society",
        imageKey: "sculptSocietyImage",
        headline: "Two Months Free of The Sculpt Society",
        description:
          "Get 2 months of the digital fitness platform free with any order ($50 value) on orders $40+.",
      },
      {
        slug: "osea-lip-booster",
        imageKey: "oseaLipBoosterImage",
        headline: "Free OSEA Hyaluronic Lip Booster Oil",
        expiresAt: "While Supplies Last",
        description:
          "Get an OSEA Hyaluronic Lip Booster Oil when you bundle two or more items ($28 value).",
      },
    ],
    disclaimerText:
      "New Year Sale offers are only available for new customers and cannot be combined with any other promotions or discounts, or applied to prior purchases, and can only be redeemed once per customer. Discount limited to a maximum of two units per unique product. Gifts are limited to one per customer and are offered only while supplies last.",
  },
  "en-GB": {
    discountPromoDetails: {
      "nys26-prospect": {
        slug: "nys26-prospect",
        headline: "40% Off Sitewide",
        description: "Get 40% off your first month’s subscription",
      },
      "nys26-customer": {
        slug: "nys26-customer",
        headline: "25% Off New Subscription Items",
        description:
          "Eligible customers will receive 25% off the regular price of any new subscription item.",
      },
    },
    promoDetails: [
      {
        slug: "sculpt-society",
        imageKey: "sculptSocietyImage",
        headline: "Two Months Free of The Sculpt Society",
        description:
          "Get 2 months of the digital fitness platform free with any order (£38 value) on orders £40+.",
      },
      {
        slug: "osea-lip-booster",
        imageKey: "oseaLipBoosterImage",
        headline: "Free OSEA Hyaluronic Lip Booster Oil",
        expiresAt: "While Supplies Last",
        description:
          "Get an OSEA Hyaluronic Lip Booster Oil when you bundle two or more items (£21 value).",
      },
    ],
    disclaimerText:
      "New Year Sale offers are only available for new customers and cannot be combined with any other promotions or discounts, or applied to prior purchases, and can only be redeemed once per customer. Discount limited to a maximum of two units per unique product. Gifts are limited to one per customer and are offered only while supplies last.",
  },
  "en-CA": {
    discountPromoDetails: {
      "nys26-prospect": {
        slug: "nys26-prospect",
        headline: "40% Off Sitewide",
        description: "Get 40% off your first month’s subscription",
      },
      "nys26-customer": {
        slug: "nys26-customer",
        headline: "25% Off New Subscription Items",
        description:
          "Eligible customers will receive 25% off the regular price of any new subscription item.",
      },
    },
    promoDetails: [
      {
        slug: "sculpt-society",
        imageKey: "sculptSocietyImage",
        headline: "Two Months Free of The Sculpt Society",
        description:
          "Get 2 months of the digital fitness platform free with any order ($70 CAD value) on orders $60+.",
      },
      {
        slug: "osea-lip-booster",
        imageKey: "oseaLipBoosterImage",
        headline: "Free OSEA Hyaluronic Lip Booster Oil",
        expiresAt: "While Supplies Last",
        description:
          "Get an OSEA Hyaluronic Lip Booster Oil when you bundle two or more items ($41 CAD value).",
      },
    ],
    disclaimerText:
      "New Year Sale offers are only available for new customers and cannot be combined with any other promotions or discounts, or applied to prior purchases, and can only be redeemed once per customer. Discount limited to a maximum of two units per unique product. Gifts are limited to one per customer and are offered only while supplies last.",
  },
};

// Default locale for fallback
const DEFAULT_LOCALE = "en-US";

/**
 * Get promo details data for the specified locale.
 * Falls back to en-US if the locale is not found.
 */
export function getPromoDetailsForLocale(locale: string): PromoDetailsData {
  return PROMO_DETAILS_BY_LOCALE[locale] || PROMO_DETAILS_BY_LOCALE[DEFAULT_LOCALE];
}

export default PROMO_DETAILS_BY_LOCALE;
